import { getListings } from "@/services/api";
import { useQuery } from "react-query";
import PropertyCard from "@/atoms/PropertyCard";
import React, { Fragment, useEffect, useState } from "react";
import DashboardButton from "@/atoms/DashboardButton";
import routes from "@/constants/routes";
import { useRouter } from "next/router";
import { useWindowSize } from "@/shared/hooks/useWindowSize";
import Screen from "@/constants/screens";
import { Listings } from "@/services/apiTypes";

const FlatsAndHousesToRent = (props: { 
  neighbourhood?: string; 
  neighbourhoodName?: string;
  title?: string;
  subtitle?: string;
}) => {
  const { neighbourhood, neighbourhoodName, title, subtitle } = props;
  const offset = 0;
  const [limit, setLimit] = useState<number>(6);
  const router = useRouter();
  const { width } = useWindowSize();
  const { data: neighbourhoodListings, isLoading: isNeighbourhoodListingsLoading } = useQuery(
    ["listings", limit],
    () => getListings({ limit, offset, neighbourhood }),
    {
      enabled: true,
    },
  );

  const { data: allListings } = useQuery(
    ["allListings", limit],
    () => getListings({ limit, offset, search: "" }),
    {
      enabled: true,
    },
  );
  // Check if the neighbourhood has listings, if not, dont show any listings
  const hasNeighbourhoodListings = (neighbourhoodListings?.result.length || 0) > 0;
  const listingsData: Listings | undefined = isNeighbourhoodListingsLoading
    ? undefined
    : hasNeighbourhoodListings
    ? neighbourhoodListings
    : neighbourhood
    ? undefined
    : allListings;

  useEffect(() => {
    if (width >= Screen.Tablet_768 && width <= Screen.DESKTOP_1280) {
      // Tablet
      setLimit(6);
    } else {
      // Mobile and desktop
      setLimit(6);
    }
  }, [width]);

  return (
    <>
      {listingsData ? (
        <>
          <div className="relative h-full bg-white w-full overflow-hidden mb-9 md:mb-0">
            <div className="flex w-full  left-0 right-0 m overflow-hidden bg-repeat-x mt-4 lg:mt-7 h-24 md:h-52 xl:h-48 bg-[url('/intermediaries/city-outline-mobile.svg')]  md:bg-[url('/intermediaries/city-outline-tablet.svg')] xl:bg-[url('/intermediaries/city-outline-desktop.svg')]" />
          </div>
          <h2 className="text-4xl mx-5 font-bold lg:text-5xl text-landing-blue text-center mt-4 md:mt-14">
            {title || "Available Keyzy homes"}{" "}
            {hasNeighbourhoodListings && neighbourhoodName ? `in ${neighbourhoodName}` : ""}
          </h2>
          <h3 className="mx-5 text-2xl font-serif lg:text-3xl text-landing-blue text-center my-6">
            {subtitle || "Be first in line to reserve homes available in London."}
          </h3>
          <section className="flex flex-wrap items-center justify-left w-auto mt-9 max-w-[90rem] mb-5 md:mb-12 mx-auto lg:px-[1.5rem]">
            {listingsData?.result.map((property, idx) => (
              <Fragment key={idx}>
                <div className={`flex flex-col w-full md:w-1/2 lg:w-1/3 mb-8 px-5 md:px-4`}>
                  <PropertyCard property={property} />
                </div>
              </Fragment>
            ))}
          </section>

          <div className="flex justify-center mb-5 w-full md:w-auto items-center px-5 md:px-0">
            <DashboardButton
              className="px-4 py-2 w-full md:w-auto rounded-sm md:rounded-lg transition duration-300 ease-in-out transform hover:scale-105"
              variant="orangeFull"
              onClick={(e) => {
                e.preventDefault;
                router.push({
                  pathname: routes.searchHomes,
                });
              }}
            >
              Search all homes
            </DashboardButton>
          </div>
        </>
      ) : null}
    </>
  );
};

export default FlatsAndHousesToRent;
